module.exports = __webpack_public_path__ + "41434794f53cf0e30faefab761b5b9dc.pdf";